import React, {useState, useEffect} from 'react';
import ImageWizardBody from './ImageWizardBody';
import Api from '../../../api/SMPFetchHelper';
import {useSMCErrorHandler} from '../../../utils/errorUtils';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import {useIsMountedRef} from '../../../utils/hooks';

function ImageWizard({
    isOpen,
    onRequestClose,
    onSuccess
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();
    const isMountedRef = useIsMountedRef();

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [fileData, setFileData] = useState(null);

    const onFinish = async () => {
        if (!name) {
            alert(t('com.sofaware.schema.ATTRIBUTE_REQUIRED_VALUE_MISSING', [t('SMP.NAME')]));
        }
        else if (!fileData || !fileData[0]) {
            alert(t('com.sofaware.db.CUSTOM_IMAGE_NO_DATA_FILE'));
        }
        else {
            setIsLoading(true);
            Api.createImage(name, fileData[0])
            .then(() => {
                if (isMountedRef.current) {
                    onSuccess(name);
                }
            })
            .catch (e => {
                if (isMountedRef.current) {
                    const errorMessage = getErrorMessage(e);
                    alert(errorMessage);
                }
            })
            .finally(() => {
                if (isMountedRef.current) {
                    setIsLoading(false);
                }
            });
        }
    }

    // Reset to defaults on every open
    useEffect(() => {
        if (isOpen) {
            setName('');
            setFileData(null);
        }
    }, [isOpen]);

    const wizardVars = {
        name, setName,
        fileData, setFileData,
    }

    return (
        <SMCModal
            title={t('SMP.NEW_CUSTOM_IMAGE_TMP_WIZ.CREATE_NEW')}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={700}
            height={650}
            loading={isLoading}
        >
            <ImageWizardBody
                onFinish={onFinish}
                onCancel={onRequestClose}
                wizardVars={wizardVars}
            />
        </SMCModal>
    );
}

export default ImageWizard;